
import '../index.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';

import {
  clearListState,
  getLegacyStoredLimit,
  getStoredListState,
  intFromParam,
  persistListState,
  updateSearchParams,
} from '../../../utils/listState';



import { ChevronLeftIcon, ChevronRightIcon } from '../../../components/ui/AppIcon';






const Component = ({ model }) => {


  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const { user, loadingSession } = useAuth();
  const canViewContent = rolePermissions.hasPermission(user, 'content.view');
  const canCreateContent = rolePermissions.hasPermission(user, 'content.create');
  const canManageContent = rolePermissions.hasPermission(user, 'content.manage');
  const canUpdateContent = rolePermissions.hasPermission(user, 'content.update');






  const persistedState = getStoredListState(`forc.list.${model.slug}.state`);

  const page = intFromParam(searchParams.get('page'), 1);
  const limit = intFromParam(
    searchParams.get('limit'),
    intFromParam(persistedState.limit, getLegacyStoredLimit(`forc.list.${model.slug}.limit`))
  );
  const sort = searchParams.get('sort') ?? persistedState.sort ?? 'updatedAt';
  const order = searchParams.get('order') ?? persistedState.order ?? 'DESC';
  const status = searchParams.get('status') ?? persistedState.status ?? '';

  const extraParams = (model.fields || []).filter((field) => {
    
    const Components = require( '../../../elements' ).default;
    
    return Components.Data.identity( field.field.value ).meta.filter;
  }).map( ( field ) => field.handle ).reduce((acc, key) => {
    acc[key] = searchParams.get(key)
      ?? persistedState[key];
    return acc;
  }, {});

  const serializedPerState = JSON.stringify({});
  const serializedExtraParams = JSON.stringify(extraParams);

  useEffect(() => {
    const persistedExtraParams = JSON.parse(serializedExtraParams);
    const persistedPerState = JSON.parse(serializedPerState);

    persistListState({
      storageKey: `forc.list.${model.slug}.state`,
      legacyLimitKey: `forc.list.${model.slug}.limit`,
      limit,
      state: {
        limit,
        sort,
        order,
        status,
        ...persistedExtraParams,
        ...persistedPerState,
      },
    });
  }, [model, limit, order, sort, status, serializedPerState, serializedExtraParams]);





  const [rows, setRows] = useState({
    data: [],
    total: 0
  });

  useEffect(() => {
  
    const loadRecords = async () => {
      setLoading(true);
      setError('');
      try {

        const result = {};

        const Factory = require( '../../../records/modules' ).default;

        const requestExtraParams = JSON.parse(serializedExtraParams);

        const filters = Object.fromEntries( Object.entries( requestExtraParams || {} ).filter( ( [, value] ) => value !== undefined && value !== null && value !== '') );

        const response = await Factory( {
          slug: model.slug
        } ).Data.getRecords( {
          page,
          limit,
          order,
          sort,
          ...(status ? { status } : {}),
          ...filters,
        } );

        const rows = response.data || [];


        result.data = await Promise.all(
          rows.map( async ( row ) => {

            const result = {};

            result.data = row;

            await Promise.all(
              model.fields.map( async ( field ) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.identity( field.field.value );

                await Component.loadData({
                  handle: field.handle,
                  meta: field.field.meta,
                  record: result.data,
                  result: result
                });
              } )
            );

            return result;
          })
        );

        result.total = response.total || 0;

        setRows( result );
      } catch (err) {
        setError(err?.response?.data?.message || err.message || 'Unable to load records.');
      } finally {
        setLoading(false);
      }
    };

    loadRecords();
  }, [ model, limit, order, page, serializedExtraParams, sort, status ]);



  const [context, setContext] = useState([]);
  const [contextLoading, setContextLoading] = useState([]);

  useEffect(() => {

    const loadContext = async () => {
      setContextLoading(true);
      setError('');
      try {

        const result = {};

        await Promise.all(
          model.fields.map( async ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Data.identity( field.field.value );
            
            await Component.loadContext({
              handle: field.handle,
              meta: field.field.meta,
              result: result
            });
          })
        );

        setContext( result );
      } catch (err) {
        setError(`Context Error: ${err?.response?.data?.message || err.message || 'Unable to load Context.'}`);
      } finally {
        setContextLoading(false);
      }
    };

    loadContext();
  }, [ model ]);

  










  const [deletingId, setDeletingId] = useState('');


  const totalPages = useMemo(() => Math.max(1, Math.ceil(rows.total / limit)), [rows.total, limit]);

  function updateParams(patch) {
    updateSearchParams(searchParams, setSearchParams, patch);
  }




  const RecordListSection = require( '../../../components/record/RecordListSection' ).default;
  
  const RecordList = require( '../../../components/view/RecordList' ).default;



  if (loadingSession) return <p>Checking access...</p>;
  if (!canViewContent) return <p className="error-text">You do not have permission to view this content.</p>;

  if (contextLoading) return <p>Loading Records...</p>;
  if (loading) return <p>Loading Records...</p>;

  const {
    handle,
    details
  } = {
    handle: {
      plural: model.plural,
      description: model.description,
    },
    section: model.section,
    slug: model.slug,
    details: {
      slug: model.slug,
      handle: model.handle,
      status: model.statusConfig,
      details: model.fields,
    }
  };

  return (
   <RecordListSection
     slug={details.slug}
     single={details.handle.label}
     error={error}
     canCreateContent={canCreateContent}
      header={{
        title: handle.plural,
        subtitle: handle.description,
        filters: {
          handleResetFilters: () => {
            clearListState(`forc.list.${details.slug}.state`, `forc.list.${details.slug}.limit`);
            setSearchParams(new URLSearchParams());
          },
          filters: (
            <>
              <label>
                Status
                <select value={status} onChange={(event) => updateParams({ status: event.target.value, page: 1 })}>
                  <option value="">All statuses</option>
                  {(details.status.options || []).map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </label>

              {(details.details || []).filter((field) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.identity( field.field.value );
                
                return Component.meta.filter;
              }).map( ( field ) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Data.identity( field.field.value );
                
                return (
                  <label>
                    {field.label}
                    <Component.Filter handle={field.handle}  meta={field.field.meta} params={{ page, limit, sort, order, status, ...extraParams }} context={context} updateParams={updateParams} />
                  </label>
                );
              })}
            </>
          ),
          focus: (
            <>
              <label>
                Sort by
                <select value={sort} onChange={(event) => updateParams({ sort: event.target.value, page: 1 })}>
                  {(details.details || []).filter((field) => {

                    const Components = require( '../../../elements' ).default;
                    
                    return Components.Data.identity( field.field.value ).meta.sort;
                  }).map( ( field ) => (
                    <option key={field.handle} value={field.handle}>{field.label}</option>
                  ))}
                </select>
              </label>
              <label>
                Order
                <select value={order} onChange={(event) => updateParams({ order: event.target.value, page: 1 })}>
                  <option value="DESC">Descending</option>
                  <option value="ASC">Ascending</option>
                </select>
              </label>
              <label>
                Rows
                <select value={limit} onChange={(event) => updateParams({ limit: event.target.value, page: 1 })}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </label>
            </>
          ),
        }
      }}
      data={{
      }}
    >

      <section className="table-card">

        <RecordList
          slug={details.slug}
          single={details.handle.label}
          order={order}
          sort={sort}
          updateParams={updateParams}
          DEFAULT_ASC_FIELDS={[ details.handle.handle ]}
          data={{
            loading: loading,
            rows: rows.data,
            canManageContent,
            canUpdateContent,
            handle: {
              column: {
                label: details.handle.label,
                field: details.handle.handle
              },
              row: {
                meta: details.handle.field.meta,
                value: details.handle.field.value,
              }
            },
            details: (() => {

              const fields = [];

              fields.push( {
                column: {
                  label: 'Status',
                  field: 'status',
                },
                row: {
                  meta: {},
                  value: 'status'
                }
              } );
              
              (details.details || []).forEach( ( field ) => {
                if ( field ) fields.push( {
                  column: {
                    label: field.label,
                    field: field.handle,
                  },
                  row: {
                    meta: field.field.meta,
                    value: field.field.value
                  }
                } );
              } );

              return fields;
            })(),
            actions: {
              deletingId: deletingId,
              handleDelete: async (id) => {
                if (!window.confirm(`Delete record?`)) {
                  return;
                }
                setDeletingId(id);
                setError('');
                try {
                  
                  const Factory = require( '../../../records/modules' ).default;

                  await Factory( {
                    slug: model.slug
                  } ).Data.deleteRecord(id);

                  if (page === 1) {
                    setRows((prev) => ({
                      data : prev.data.filter((row) => row.data.id !== id),
                      total: Math.max(0, prev.total - 1)
                    }));
                  } else {
                    updateParams({ page: 1 });
                  }
                } catch (err) {
                  setError(err?.response?.data?.message || err.message || 'Unable to delete record.');
                } finally {
                  setDeletingId('');
                }
              }
            }
          }}
        />

        <div className="table-card-footer">
          <span className="table-record-count">{rows.total ?? 0} records</span>
          <div className="pagination-controls">
            <button
              aria-label="Previous page"
              className="pagination-icon-btn"
              disabled={(page ?? 1) <= 1}
              onClick={() => updateParams({ page: page - 1 })}
              type="button"
            >
              <ChevronLeftIcon />
            </button>
            <span className="pagination-label">Page {page} of {totalPages}</span>
            <button
              aria-label="Next page"
              className="pagination-icon-btn"
              disabled={(page ?? 1) >= totalPages}
              onClick={() => updateParams({ page: page + 1 })}
              type="button"
            >
              <ChevronRightIcon />
            </button>
          </div>
        </div>

      </section>

    </RecordListSection>
  );
};




export default Component;